// this file added by Bearer Web Developer
import React, { useEffect } from "react";
import { Button, CircularProgress, Dialog } from "@mui/material";
import styles from './imagePopup.module.scss';
import { fetchDownloadUrl } from "../../../../api/bearer-api";
interface Props {
    url: string
    open: boolean
    handleClose: () => void
}
const ImagePopup: React.FC<Props> = ({ url, open, handleClose }) => {

    const [preview, setPreview] = React.useState({ loading: true, value: '' });
    useEffect(() => {
        (async () => {
            try {
                const result = await fetchDownloadUrl(url);
                if (result) {
                    setPreview({ loading: false, value: result });
                }
            } catch (error) {
                setPreview(prev => ({ ...prev, loading: false }));
            }
        })();
    }, [url])
    return (
        <Dialog open={open} onClose={handleClose} PaperProps={{ style: { borderRadius: "10px" } }}
            classes={{ paper: styles.paper_dialog, root: styles.root_dialog }}>
            <section className={styles.root}>
                <header className={styles.header}>
                    <h4>Verification Photo</h4>
                    <Button onClick={handleClose} classes={{ root: styles.root_button }}><img src="/cancel.png" alt="back" /></Button>
                </header>
                {preview?.loading ?
                    <div className={styles.loading}><CircularProgress /></div> :
                    <div className={styles.image}>
                        <img src={preview?.value} height={353} />
                    </div>
                }
            </section>
        </Dialog>
    )
}
export default ImagePopup;